import React, { ComponentProps } from 'react';
import { createPortal } from 'react-dom';
import { Modal as CarbonModal } from '@carbon/react';

export type ModalProps = ComponentProps<typeof CarbonModal>;

export const Modal = ({ children, ...props }: ModalProps) =>
  createPortal(<CarbonModal {...props}>{children}</CarbonModal>, document.body);

Modal.displayName = 'Modal';
